import { BModal } from 'bootstrap-vue'
import { PropType } from 'vue'
import Component from 'vue-class-component'

import { Item, SearchFeatured } from '@skinsoft/types'
import { ReactiveVue } from '@skinsoft/reactive-vue'
import { SelectItemMultipleForm } from './select-item-multiple-form'
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons'
import { BarCodeEditor } from '../../../app/component/action-bar/map-icon-toggle/bar-code-editor'
import { LINK_MOVEMENT_PAGE_NAVIGATE } from '../../../events'

require('./select-item-multiple-modal.scss')

@Component({
    components: {
        sSelectItemMultipleForm: SelectItemMultipleForm,
        sBarCodeEditor: BarCodeEditor,
    },
    props: {
        canChainAdd: {
            type: Boolean,
            default: true
        },
        updating: Boolean,
        canChangeMode: {
            type: Boolean,
            default: false,
        },
        showLinksToMovements: {
            type: Boolean,
            default: false
        },
        excludedItemsWarningMessageKey: {
            type: String,
        },
        types: Array as PropType<string[]>
    },
    template: require('./select-item-multiple-modal.html'),
})
export class SelectItemMultipleModal extends ReactiveVue {
    public mounted = false
    public spinnerIcon = faCircleNotch
    public locationSelector = true

    public canChainAdd: boolean
    public updating: boolean
    public canChangeMode: boolean
    public types: Array<string>
    private showLinksToMovements: boolean
    private excludedItemsWarningMessageKey: string

    public shouldChainAdd: boolean = false

    private LINK_MOVEMENT_PAGE_NAVIGATE = LINK_MOVEMENT_PAGE_NAVIGATE


    public $refs: {
        modal: BModal
        itemSelect: SelectItemMultipleForm
    }

    public open() {
        this.$refs.modal.show()
    }

    public close() {
        this.$refs.modal.hide()
    }

    public onShow() {
        this.mounted = true
    }

    public onHide() {
        this.mounted = false
    }

    public onItemSelected(featured: SearchFeatured | Item, searchContent: string, currentPage: number) {
        // @ts-ignore
        this.$emit('item-selected', { id: featured.itemId ?? featured.id, type: featured.itemType ?? featured.entityType })
        if (!this.canChainAdd || !this.shouldChainAdd) {
            this.close()
        }
    }

    public resetSearch() {
        this.$nextTick(() => this.$refs.itemSelect?.resetSearch())
    }
}
